import React, { Component } from "react";
import { BrowserRouter, Link, Switch, Route } from "react-router-dom";
import "./App.css";
import Business from "./pages/Business";
import Home from "./pages/Home";
import Team from "./pages/Team";
import Contact from "./pages/Contact";
import ContactThankYou from "./pages/ContactThankYou";
import SlackAuth from "./pages/SlackAuth";
import Privacy from "./pages/Privacy";
import HandleLink from "./pages/HandleLink";
import { Document, Page } from "react-pdf";
import { pdfjs } from 'react-pdf';
import Kinder_How_It_Works from "./assets/Kinder_How_It_Works.pdf"
import ProhibitedUse from "./pages/ProhibitedUse";
import Terms from "./pages/TOS";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


class App extends Component {
  constructor(props) {
    super(props);
    this.state = { width: 0, height: 0, numPages: null, pageNumber: 1 };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }

  render() {
    const { pageNumber, numPages } = this.state;

    return (
      <BrowserRouter>
        <main>
          <Switch>
            <Route
              exact
              path="/"
              render={props => (
                <Home
                  {...props}
                  width={this.state.width}
                  height={this.state.height}
                />
              )}
            />
            <Route
              path="/mutualaid"
              component={() => window.location = 'https://drive.google.com/file/d/1T3nYtvAyhefscfjPfTUQ0Ln-MoHIYwuk/view'}

              //render={props => (
                // <div>
                //   <Document
                //     file={Kinder_How_It_Works}
                //     onLoadSuccess={this.onDocumentLoadSuccess}
                //   >
                //     <Page pageNumber={1} />
                //     <Page pageNumber={2} />
                //     <Page pageNumber={3} />
                //     <Page pageNumber={4} />
                //     <Page pageNumber={5} />


                //   </Document>
                //   {/* <p>
                //     Page {pageNumber} of {numPages}
                //   </p> */}
                // </div>
              //)}
            />
            <Route
              path="/slack-authentication"
              
              render={props => (
                <SlackAuth
                  {...props}
                  width={this.state.width}
                  height={this.state.height}
                />
              )}
            />
            <Route
              exact
              path="/privacy"
              render={props => (
                <Privacy
                  {...props}
                  width={this.state.width}
                  height={this.state.height}
                />
              )}
            />
            <Route
              exact
              path="/prohibited-use"
              render={props => (
                <ProhibitedUse
                  {...props}
                  width={this.state.width}
                  height={this.state.height}
                />
              )}
            />
             <Route
              exact
              path="/terms"
              render={props => (
                <Terms
                  {...props}
                  width={this.state.width}
                  height={this.state.height}
                />
              )}
            />
            <Route
              exact
              path="/handle-link"
              render={props => (
                <HandleLink
                  {...props}
                  width={this.state.width}
                  height={this.state.height}
                />
              )}
            />
            {/* <Route
              path="/team"
              render={props => (
                <Team
                  {...props}
                  width={this.state.width}
                  height={this.state.height}
                />
              )}
            />
             */}
          </Switch>
        </main>
      </BrowserRouter>
    );
  }
}

export default App;
